export default {
  title: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_reasons_title',
    defaultMessage:
      'Why do you think the Back Market customer’s assessment is inaccurate?',
  },
  infoBlock: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_reasons_info',
    defaultMessage: 'Battery issues are not valid reasons for counteroffers.',
  },
  requiredErrorMessage: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_reasons_error_message',
    defaultMessage:
      'To submit a counteroffer you have to select at least one reason',
  },
}
